import classNames from 'classnames';

import { ToothIcon } from '../../../common-components/elements/icon/svgs/ToothIcon';
import { black } from '../../../theme/videa-style-tokens';

interface Props {
  mouthAreas: string[];
}

export const ToothIconAndMouthAreas = ({ mouthAreas }: Props) => {
  if (!mouthAreas.length) return null;

  return (
    <div
      className={classNames('vai-flex vai-items-center vai-gap-2', {
        'vai-flex-wrap': mouthAreas.length > 1,
      })}
    >
      <ToothIcon fill={black} />
      {mouthAreas.map((mouthArea) => (
        <p className="vai-typography-p" key={mouthArea}>
          {mouthArea}
        </p>
      ))}
    </div>
  );
};
